import { Calendar } from "primereact/calendar"
import { useTranslation } from "react-i18next";
import { ResponsiveContainer, CartesianGrid, XAxis, YAxis, Legend, AreaChart, Area, Tooltip, LineChart, Line, ComposedChart } from "recharts"


export const BloodPressureHistoryGraph = ({
    bpData,
    date,
    onDateChange = (e) => { }
}) => {

    const [t] = useTranslation(["global", "health"]);

    // Funzioni per ottenere inizio e fine della giornata
    const getStartOfDay = () => Math.floor(date.setHours(0, 0, 0, 0));
    const getEndOfDay = () => Math.floor(date.setHours(23, 59, 59, 999));

    const CustomTooltip = ({ active, payload, label }) => {
        if (active && payload && payload.length) {
            console.log("BP:--->" + JSON.stringify(payload))
            return (
                <div className="custom-tooltip bg-dark card">
                    <div className="card-body">
                        <span>SYS <b>{payload[0].value}</b> <small className="text-muted"> mmHg</small></span><br />
                        <span>DIA <b>{payload[1].value}</b> <small className="text-muted"> mmHg</small></span>
                    </div>
                    <div className="card-footer"> {new Date(label * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })}</div>

                </div>
            );
        }

        return null;
    };


    return <div className="card mt-2 bg-black bg-opacity-10 text-white p-4">
        <div className="d-flex  justify-content-between mb-3">
            <div>
                <h4><i className="fa-solid fa-wind text-muted"></i> {t("health:entity.data.blood_pressure")}</h4>
                <span className="small text-muted">{bpData.length} {t("health:unit.measurements", { count: bpData.length })}</span>
            </div>
            <div>
                <Calendar value={date} onChange={(e) => onDateChange(e.value)} dateFormat="dd/mm/yy" />
            </div>
        </div>

        {
            bpData?.length > 0 ?
                <ResponsiveContainer width="100%" height={400}>
                    <ComposedChart data={bpData} margin={{ top: 10, right: 30, left: 0, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" opacity={0.5}/>
                        <XAxis
                            dataKey="timestamp"

                            type="number"
                            domain={[getStartOfDay() / 1000, getEndOfDay() / 1000]}
                            tickFormatter={(tick) =>
                                new Date(tick * 1000).toLocaleTimeString("it-IT", { hour: "2-digit", minute: "2-digit" })
                            }
                            ticks={[(getStartOfDay() / 1000, getStartOfDay() / 1000) + 21600, (+getStartOfDay() / 1000) + 43200, (+getStartOfDay() / 1000) + 64800, getEndOfDay() / 1000]}
                            scale="time"
                        />
                        <YAxis
                            dataKey="sbp"
                            type="number"
                            scale="linear"
                            domain={[60, 180]}
                        />
                        <Tooltip content={CustomTooltip} />
                        <Legend />
                        <Line type="monotone" dot={false} dataKey="sbp" name={`SYS mmHg`} fill="rgb(23, 218, 169)" stroke="rgb(23, 218, 169)" strokeWidth={2} />
                        <Line type="monotone" dot={false} dataKey="dbp" name={`DIA mmHg`} fill="rgb(206, 44, 187)" stroke="rgb(206, 44, 187)" strokeWidth={2} />
                    </ComposedChart>
                </ResponsiveContainer>
                : <h3 className="text-muted">{t("health:helper.no_data")}</h3>
        }
    </div>
}